import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  enotesChapterData: [],
  totalenotesChapter: 0,
  isOpenModal: false,
  isPdfOpenModal: false,
}

export const enotesChapterSlice = createSlice({
  name: "enotesChapter",
  initialState,
  reducers: {
    setenotesChapterData(state, { payload }) {
      console.log(payload)
      state.enotesChapterData = payload.result
      state.totalenotesChapter = payload.count
    },
    updateenotesChapterData(state, { payload }) {
      const objIndex = state.enotesChapterData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.enotesChapterData[objIndex] = payload
      }
    },
    deleteenotesChapterData(state, { payload }) {
      const objIndex = state.enotesChapterData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.enotesChapterData.splice(objIndex, 1)
      }
    },
    pushenotesChapterData(state, { payload }) {
      state.enotesChapterData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isPdfOpenModal(state, { payload }) {
      state.isPdfOpenModal = payload
    },
    PdfstatusToggle(state, { payload }) {
      state.isPdfOpenModal = !state.isPdfOpenModal
    }
  }
})

export const { setenotesChapterData, updateenotesChapterData, deleteenotesChapterData, pushenotesChapterData, isOpenModal,
  ModalToggle, isPdfOpenModal, PdfstatusToggle } = enotesChapterSlice.actions;

export default enotesChapterSlice.reducer;

export function getenotesChapter(limit, offset, id) {
  return async function getenotesChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getenotesChapter(limit, offset, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setenotesChapterData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addenotesChapter(data) {
  return async function addenotesChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addenotesChapter(data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushenotesChapterData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateenotesChapter(id, data) {
  return async function updateenotesChapterThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateenotesChapter(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateenotesChapterData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function deletEnotesChapter(id) {
  return async function deletEnotesThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deletEnotesChapter(id).then(
        (response) => {
          dispatch(deleteenotesChapterData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateEnotesPdfChapter(id, file) {
  return async function updateEnotesPdfChapterThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.updateEnotesPdfChapter(id, file).then(
        (response) => {
          dispatch(PdfstatusToggle())
          dispatch(updateenotesChapterData(response.data))
          dispatch(setLoading(false))
          successHandler('Pdf Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



